import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function actionCardContent(theme: Theme): ComponentStyle {
  return {
    componentName: 'actionCardContent',
    baseStyle: {
      padding: theme.space['s']
    }
  };
}
